module.exports = __webpack_public_path__ + "public/img/shangri.fa1d52cb.png";